import {Data} from './Data';
import local from './common/polyfill';
import {$subscriber} from "fire-wind-water";

export class Piwik extends Data {
  constructor(url) {
    super(url);
    this.search = {};
    this.matomoUrl = null;
    this.url = url;
    this.jsonParams = null;
    this.u = '';
  }

  isTypes() {
    if (!this.url) {
      return;
    }
    var search = window.location.search.substr(1);
    var searchArr = search.split('&');
    for (var i = 0; i < searchArr.length; i++) {
      var d = searchArr[i].split('=');
      this.search[d[0]] = d[1];
    }
    var types = [
      {id: 'bigScreenId', type: 'bigScreen'}, // 线下会大屏
      {id: 'seminarId', type: 'seminar'}, // 线下会专题站
      {id: 'webinarId', type: 'webinar'}, // 线上会直播，点播
      {id: 'memberFormId', type: 'memberForm'}, // 注册表单
      {id: 'customFormId', type: 'customForm'}, // 表单
      {id: 'questionaryId', type: 'question'}, // 问卷
      {id: 'pollId', type: 'poll'}, // 投票
      {id: 'luckyDrawId', type: 'luckyDraw'}, // 抽奖
      {id: 'topicId', type: 'topic'}, // 微讨论 互动社区
      {id: 'folderId', type: 'fileFolder'}, // 文件模板文件夹
      {id: 'fileId', type: 'file'}, // 文件模板文件
      {id: 'articleCategoryId', type: 'articleCategory'}, // 文章栏目
      {id: 'articleId', type: 'article'}, // 文章
      {id: 'instanceId', type: 'instance'} // 实例ID
    ];
    if (window['$s-temp-piwikInfo']) {
      this.getJsonParams(window['$s-temp-piwikInfo']);
    } else {
      var info = null;
      for (i = 0; i < types.length; i++) {
        var t = types[i];
        if (this.search[t.id]) {
          info = {
            id: this.search[t.id],
            type: t.type
          };
          break;
        }
      }
      if (info) {
        this.getJsonParams(info);
        return;
      }
      // 没有匹配到，再次尝试匹配租户id
      if (this.search && this.search.tenantId) {
        this.getJsonParams({tenantId: this.search.tenantId, id: '', type: 'tenant'});
      }
    }
  }

  resetPiwik(u){
    if(window.Piwik){
      var piwikTracker = window.Piwik.getTracker();
      piwikTracker.setSiteId(2000);
      piwikTracker.setTrackerUrl(u + 'matomo.php');
      piwikTracker.trackPageView();
    } else {
      setTimeout(() => {
        this.resetPiwik(u);
      }, 500);
    }
  }

  JsonParamsCallback(data) {
    const _this = this;
    if (data.result == '0') {
      this.jsonParams = data.content;
      local.$s_temp.change('jsonParams', data.content);
      $subscriber.emit('jsonParams',data.content);
      this.u = _this.matomoUrl || (window.config ? window.config.matomoUrl : '');
      if (window.$s_temp_config) {
        this.u = window.$s_temp_config.matomoUrl;
      }
      if(!this.u){
        return;
      }
      this.setPiwik();
    }
  }

  initPiwikSiteId(id) {
    this.JsonParamsCallback({
      result: 0,
      content: {
        siteId: id
      }
    });
  }

  initPiwikTenantId(id) {
    this.getJsonParams({tenantId: id, id: '', type: 'tenant'});
  }

  initPiwikPostUrl(url) {
    this.matomoUrl = url.matomoUrl;
    this.setDataUrl(url.apiUrl);
  }

  initPiwikApiUrl(url) {
    this.setDataUrl(url);
  }

  initMatomoUrl(url) {
    this.matomoUrl = url;
  }

  setPiwik(){
    if(!this.jsonParams){
      return;
    }
    if (!window._paq) {
      window._paq = [];
    }
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);
    window._paq.push(['setTrackerUrl', this.u + 'matomo.php']);
    window._paq.push(['setSiteId', this.jsonParams.siteId]);
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.async = true;
    g.defer = true;
    g.src = this.u + 'matomo.js';
    s.parentNode.insertBefore(g, s);

    this.resetPiwik(this.u);

    if (this.jsonParams.tenantId == '949') {
      var _hmt = _hmt || [];
      if (!window._hmt) {
        window._hmt = [];
      }
      (function() {
        var hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?c9a04a03ec6e1530687e948ade6d5074';
        hm.async = true;
        // var s = document.getElementsByTagName("script")[0];
        // s.parentNode.insertBefore(hm, s);
        document.head.appendChild(hm);
      })();
    }
  }
}
